// Fornecedor e Cliente compartilham o mesmo formato de identificação:
// pessoa jurídica usa razao_social (nome_fantasia é opcional e não existe
// pra pessoa física); pessoa física usa nome_completo. Mostrar só
// nome_fantasia (ou só nome_completo) deixa a outra metade dos
// cadastros sem nome nenhum na tela — foi exatamente esse bug em CP/CR.
export function nomePessoa(pessoa) {
  if (!pessoa) return null;
  if (pessoa.tipo_pessoa === 'F') return pessoa.nome_completo || null;
  return pessoa.razao_social || pessoa.nome_fantasia || null;
}
